import React from 'react';
import { Section, SectionHeading } from '../ui/Section';
const steps = [{
  title: 'Understand',
  body: 'Your people, applications, priorities and concerns.'
}, {
  title: 'Map',
  body: 'Responsibility across support, security, infrastructure and vendors.'
}, {
  title: 'Confirm',
  body: 'Dependencies, timing, decision points and any future scope.'
}, {
  title: 'Change',
  body: 'Only what is approved, staged around business continuity.'
}];
export function Process() {
  return <Section id="process" className="bg-white" ariaLabel="Controlled transition process" data-id="element-351" data-mp="3nknn35yqazt9">
      <div className="grid gap-10 lg:grid-cols-2 lg:items-start" data-id="element-352" data-mp="63vz1yur2yov">
        <SectionHeading eyebrow="Risk reversal" title="Clarity first. Change only when you choose." body="The free Review can stand on its own. If CT Group is the right fit, any transition is planned around business continuity, not an automatic rip-and-replace." data-id="element-353" data-mp="65737zs3y8gi" />
        <ol className="grid border-l border-t border-border sm:grid-cols-2" data-id="element-354" data-mp="34sus5603n4iw">
          {steps.map((step, index) => <li key={step.title} className="flex min-h-[190px] flex-col border-b border-r border-border p-6" data-id="element-355" data-mp="2mradlccnx2vx" data-mpi={index}>
              <span className="font-display text-[12px] font-black text-ct-cyan" data-id="element-356" data-mp="2rp25459eamzl">0{index + 1}</span>
              <h3 className="mt-8 font-display text-[24px] font-black text-navy" data-id="element-357" data-mp="2wieq85ev8bnl">{step.title}</h3>
              <p className="mt-2 text-[14px] leading-relaxed text-slate" data-id="element-358" data-mp="30if4nq1ysmun">{step.body}</p>
            </li>)}
        </ol>
      </div>
    </Section>;
}